import { setMaintenanceCarryOvers } from '../../services/maintenanceCarryOver';
import { notify } from '../../store/feedback';

/* Report de maintenance en fin d'année de contrat (arbitrage du 14/10/2026) : les quantités,
   saisies à la main ({ correctif, evolutif }), s'ajoutent aux quotas de l'année qui commence le
   `nextFrom`. */
export default function maintenanceCarryOverHandlers(deps) {
  const { update } = deps;

  async function saveMaintenanceCarryOver(phase, nextFrom, quantities) {
    const reports = { ...(phase.maintenanceReports || {}), [nextFrom]: quantities };
    const { error } = await setMaintenanceCarryOvers(phase.id, reports);
    if (error) return void notify('Erreur enregistrement du report : ' + error.message);
    update((s) => ({
      ...s,
      clients: s.clients.map((c) => ({
        ...c,
        phases: c.phases.map((ph) =>
          ph.id === phase.id ? { ...ph, maintenanceReports: reports } : ph,
        ),
      })),
    }));
    notify('Report enregistré.', 'success');
  }

  return { saveMaintenanceCarryOver };
}
